// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tiles":"entry-dashboard-main__tiles___3m3u0","tile":"entry-dashboard-main__tile___tDcnZ","help-center":"entry-dashboard-main__help-center___1UM5c","helpCenter":"entry-dashboard-main__help-center___1UM5c","tile-count":"entry-dashboard-main__tile-count___1e0HF","tileCount":"entry-dashboard-main__tile-count___1e0HF","tile-count-total":"entry-dashboard-main__tile-count-total___24K2L","tileCountTotal":"entry-dashboard-main__tile-count-total___24K2L"};
    if(module.hot) {
      // 1695351554765
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  